/**
 * Router which renders views related to `Organization` models.
 * @module app/routers/admin/Organizations
 */
import RouterBase from "app/routers/RouterBase";
import _ from "underscore";
import $ from "jquery";
import OrganizationCollection from "app/models/OrganizationCollection";
import IndexView from "app/views/admin/organizations/Index";
import DetailView from "app/views/admin/organizations/Details";
import Field from "core/models/Field";
import Organization from "app/models/Organization";
import FormView from "core/views/FormView";
import ModelOperations from "core/operations/ModelOperations";
import NavigationOperations from "core/operations/NavigationOperations";
import RequestUtils from "app/utils/RequestUtils";
import urlService from "app/UrlService";
import app from "app/App";
export default RouterBase.extend({
  root: "/admin/organizations",
  initialize: function (options) {
    RouterBase.prototype.initialize.apply(this, arguments);
  },

  load: function () {
    this.collection = new OrganizationCollection([]);

    return RequestUtils.fetchToPromise(this.collection);
  },

  routerSettings: {
    title: "Organizations",
  },

  routes: {
    "admin/organizations": "list",
    "admin/organizations/Details/:id": "details",
    "admin/organizations/Create": "create",
    "admin/organizations/Edit/:id": "edit",
  },

  /**
   * Renders a list of organizations.
   */
  list: function () {
    var view = new IndexView({
      models: this.collection,
    });

    view.render();
    app.registerItemAction(
      NavigationOperations.createNavigationOperation("Create", "plus", "Create")
    );
    app.pushView(view);
  },

  /**
   * Renders a view which shows organization details.
   * @param  {string} id The ID of the organization to display.
   */
  details: function (id) {
    var view = new DetailView({
      model: this.collection.get(id),
    });

    view.render();

    app.registerNavigationAction("back");
    app.registerItemAction(
      NavigationOperations.createNavigationOperation(
        "Edit",
        "pencil",
        "Edit/" + id
      )
    );

    app.setLayout("Wide").done(function () {
      app.pushView(view);
    });
  },

  _formFields: function (fields) {
    if (!fields) {
      fields = [
        "PrimaryName",
        "Address",
        "PhoneNumber",
        "EmailAddress",
        "background-image",
        "header-color",
      ];
    }

    return _.map(fields, function (fieldName) {
      return new Field(Organization.fields[fieldName]);
    });
  },

  //attach a "preview" style to the DOM to let users see a live preview of skinning changes.
  _attachStyle: function (view, model) {
    var style = $('<style type="text/css"></style>');

    style.attr("id", _.uniqueId("style"));

    function updateStyle(model) {
      var css = "";

      if (model.get("background-image")) {
        css +=
          ".navbar-brand-with-image {background-image: url(" +
          urlService.apiurl(
            "/document/" +
              model.get("background-image") +
              "/file/" +
              encodeURIComponent(model.get("Name"))
          ) +
          ")} ";
      }

      if (model.get("header-color")) {
        css +=
          ".page-header-container {background-color: " +
          model.get("header-color") +
          "} ";
      }

      style.html(css);
    }

    model.on(
      "change:background-image change:header-color",
      function () {
        updateStyle(model);
      },
      this
    );
    updateStyle(model);
    $("head").append(style);

    return style;
  },

  _detachStyle: function (style) {
    style.remove();
  },

  _renderFormView: function (model) {
    var view = new FormView({
      fields: this._formFields(),
      model: model,
      className: (FormView.prototype.className || "") + " organization-create",
    });

    var style = this._attachStyle(view, model);
    //the route event apparently fires after this function is called, so we need to wait until after
    //it is triggered to attach our event handlers.
    _.defer(
      _.bind(function () {
        this.once(
          "route leave",
          function () {
            this._detachStyle(style);
          },
          this
        );
      }, this)
    );

    view.render();

    return view;
  },

  /**
   * Renders a view which can be used to create a organization.
   */
  create: function () {
    var model = new Organization();

    model.collection = this.collection;

    var view = this._renderFormView(model);

    app.registerNavigationAction("back");
    app.registerItemAction(
      ModelOperations.create("Organization", view, this.collection, true),
      model
    );

    app.pushView(view);

    setTimeout(function () {
      view.delegateEvents();
    }, 1000);
  },

  /**
   * Renders a view which can be used to modify a organization.
   * @param  {string} id The ID of the organization to modify.
   */
  edit: function (id) {
    var model = this.collection.get(id);
    var view = this._renderFormView(model);

    app.registerNavigationAction("back");
    app.registerItemAction(
      ModelOperations.destroy("Organization", this.collection),
      model
    );
    app.registerItemAction(
      ModelOperations.save("Organization", view, true),
      model
    );

    app.pushView(view);

    setTimeout(function () {
      view.delegateEvents();
    }, 1000);
  },
});



//////////////////
// WEBPACK FOOTER
// ./public/js/app/routers/admin/Organizations.js
// module id = 920
// module chunks = 1